// hooks/usePagesConfigListener.ts
import { useEffect } from 'react';
import { titleService } from './titleService';

export const usePagesConfigListener = (): void => {
  useEffect(() => {
    const handleStorageChange = (event: StorageEvent): void => {
      if (event.key === 'pages' || event.key === null) {
        titleService.reloadConfig();
        console.log('Pages config reloaded');
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
};